import { BuildModuleParamsType } from 'types/api-internal';
import { SugarMoneyApiGetFeesResponseType } from 'types/fees';

export const feesModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  get: async () =>
    makeApiRequest<SugarMoneyApiGetFeesResponseType>({
      endpoint: 'fees',
      options: { method: 'get' },
    }),
});
